// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from './schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type DocumentRecordQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type DocumentRecordQuery = { __typename?: 'Query', documentRecord: { __typename?: 'DocumentRecord', id: string, workspaceId: string, documentCollectionId: string, version: number, values: any, createdByUserId?: string | null, updatedByUserId?: string | null, createdAt: any, updatedAt: any } };

export type DocumentRecordsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ListDocumentRecordsInput>;
}>;


export type DocumentRecordsQuery = { __typename?: 'Query', documentRecords: { __typename?: 'DocumentRecordConnection', nodes: Array<{ __typename?: 'DocumentRecord', id: string, workspaceId: string, documentCollectionId: string, version: number, values: any, createdByUserId?: string | null, updatedByUserId?: string | null, createdAt: any, updatedAt: any }>, pageInfo: { __typename?: 'DocumentRecordPageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type DocumentRecordSyncCursorQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DocumentRecordSyncCursorQuery = { __typename?: 'Query', documentRecordSyncCursor: string };

export type DocumentRecordRevisionsQueryVariables = Types.Exact<{
  recordId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  afterVersion?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type DocumentRecordRevisionsQuery = { __typename?: 'Query', documentRecordRevisions: { __typename?: 'DocumentRecordRevisionConnection', nodes: Array<{ __typename?: 'DocumentRecordRevision', id: string, recordId: string, version: number, values: any, actorUserId?: string | null, createdAt: any }>, pageInfo: { __typename?: 'DocumentRecordPageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type DocumentRecordChangesQueryVariables = Types.Exact<{
  after: Types.Scalars['String']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type DocumentRecordChangesQuery = { __typename?: 'Query', documentRecordChanges: { __typename?: 'DocumentRecordChangePage', cursor: string, resetRequired: boolean, changes: Array<{ __typename?: 'DocumentRecordChange', cursor: string, recordId: string, version: number, type: Types.DocumentRecordChangeType, snapshot?: any | null }> } };

export type CreateDocumentRecordMutationVariables = Types.Exact<{
  input: Types.CreateDocumentRecordInput;
}>;


export type CreateDocumentRecordMutation = { __typename?: 'Mutation', createDocumentRecord: { __typename?: 'DocumentRecord', id: string, workspaceId: string, documentCollectionId: string, version: number, values: any, createdByUserId?: string | null, updatedByUserId?: string | null, createdAt: any, updatedAt: any } };

export type PatchDocumentRecordMutationVariables = Types.Exact<{
  input: Types.PatchDocumentRecordInput;
}>;


export type PatchDocumentRecordMutation = { __typename?: 'Mutation', patchDocumentRecord: { __typename?: 'DocumentRecord', id: string, workspaceId: string, documentCollectionId: string, version: number, values: any, createdByUserId?: string | null, updatedByUserId?: string | null, createdAt: any, updatedAt: any } };

export type DeleteDocumentRecordMutationVariables = Types.Exact<{
  input: Types.DeleteDocumentRecordInput;
}>;


export type DeleteDocumentRecordMutation = { __typename?: 'Mutation', deleteDocumentRecord: boolean };

export type ImportDocumentRecordsMutationVariables = Types.Exact<{
  inputs: Array<Types.CreateDocumentRecordInput> | Types.CreateDocumentRecordInput;
}>;


export type ImportDocumentRecordsMutation = { __typename?: 'Mutation', importDocumentRecords: Array<{ __typename?: 'DocumentRecord', id: string, workspaceId: string, documentCollectionId: string, version: number, values: any, createdByUserId?: string | null, updatedByUserId?: string | null, createdAt: any, updatedAt: any }> };


export const DocumentRecordDocument = gql`
    query DocumentRecord($id: String!) {
  documentRecord(id: $id) {
    id
    workspaceId
    documentCollectionId
    version
    values
    createdByUserId
    updatedByUserId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useDocumentRecordQuery__
 *
 * To run a query within a React component, call `useDocumentRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentRecordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentRecordQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentRecordQuery, DocumentRecordQueryVariables> & ({ variables: DocumentRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentRecordQuery, DocumentRecordQueryVariables>(DocumentRecordDocument, options);
      }
export function useDocumentRecordLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentRecordQuery, DocumentRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentRecordQuery, DocumentRecordQueryVariables>(DocumentRecordDocument, options);
        }
// @ts-ignore
export function useDocumentRecordSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordQuery, DocumentRecordQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentRecordQuery, DocumentRecordQueryVariables>;
export function useDocumentRecordSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordQuery, DocumentRecordQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentRecordQuery | undefined, DocumentRecordQueryVariables>;
export function useDocumentRecordSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordQuery, DocumentRecordQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentRecordQuery, DocumentRecordQueryVariables>(DocumentRecordDocument, options);
        }
export type DocumentRecordQueryHookResult = ReturnType<typeof useDocumentRecordQuery>;
export type DocumentRecordLazyQueryHookResult = ReturnType<typeof useDocumentRecordLazyQuery>;
export type DocumentRecordSuspenseQueryHookResult = ReturnType<typeof useDocumentRecordSuspenseQuery>;
export type DocumentRecordQueryResult = ApolloReactCommon.QueryResult<DocumentRecordQuery, DocumentRecordQueryVariables>;
export const DocumentRecordsDocument = gql`
    query DocumentRecords($input: ListDocumentRecordsInput) {
  documentRecords(input: $input) {
    nodes {
      id
      workspaceId
      documentCollectionId
      version
      values
      createdByUserId
      updatedByUserId
      createdAt
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useDocumentRecordsQuery__
 *
 * To run a query within a React component, call `useDocumentRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentRecordsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDocumentRecordsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DocumentRecordsQuery, DocumentRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentRecordsQuery, DocumentRecordsQueryVariables>(DocumentRecordsDocument, options);
      }
export function useDocumentRecordsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentRecordsQuery, DocumentRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentRecordsQuery, DocumentRecordsQueryVariables>(DocumentRecordsDocument, options);
        }
// @ts-ignore
export function useDocumentRecordsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordsQuery, DocumentRecordsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentRecordsQuery, DocumentRecordsQueryVariables>;
export function useDocumentRecordsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordsQuery, DocumentRecordsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentRecordsQuery | undefined, DocumentRecordsQueryVariables>;
export function useDocumentRecordsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordsQuery, DocumentRecordsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentRecordsQuery, DocumentRecordsQueryVariables>(DocumentRecordsDocument, options);
        }
export type DocumentRecordsQueryHookResult = ReturnType<typeof useDocumentRecordsQuery>;
export type DocumentRecordsLazyQueryHookResult = ReturnType<typeof useDocumentRecordsLazyQuery>;
export type DocumentRecordsSuspenseQueryHookResult = ReturnType<typeof useDocumentRecordsSuspenseQuery>;
export type DocumentRecordsQueryResult = ApolloReactCommon.QueryResult<DocumentRecordsQuery, DocumentRecordsQueryVariables>;
export const DocumentRecordSyncCursorDocument = gql`
    query DocumentRecordSyncCursor {
  documentRecordSyncCursor
}
    `;

/**
 * __useDocumentRecordSyncCursorQuery__
 *
 * To run a query within a React component, call `useDocumentRecordSyncCursorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentRecordSyncCursorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentRecordSyncCursorQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentRecordSyncCursorQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DocumentRecordSyncCursorQuery, DocumentRecordSyncCursorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentRecordSyncCursorQuery, DocumentRecordSyncCursorQueryVariables>(DocumentRecordSyncCursorDocument, options);
      }
export function useDocumentRecordSyncCursorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentRecordSyncCursorQuery, DocumentRecordSyncCursorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentRecordSyncCursorQuery, DocumentRecordSyncCursorQueryVariables>(DocumentRecordSyncCursorDocument, options);
        }
// @ts-ignore
export function useDocumentRecordSyncCursorSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordSyncCursorQuery, DocumentRecordSyncCursorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentRecordSyncCursorQuery, DocumentRecordSyncCursorQueryVariables>;
export function useDocumentRecordSyncCursorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordSyncCursorQuery, DocumentRecordSyncCursorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentRecordSyncCursorQuery | undefined, DocumentRecordSyncCursorQueryVariables>;
export function useDocumentRecordSyncCursorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordSyncCursorQuery, DocumentRecordSyncCursorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentRecordSyncCursorQuery, DocumentRecordSyncCursorQueryVariables>(DocumentRecordSyncCursorDocument, options);
        }
export type DocumentRecordSyncCursorQueryHookResult = ReturnType<typeof useDocumentRecordSyncCursorQuery>;
export type DocumentRecordSyncCursorLazyQueryHookResult = ReturnType<typeof useDocumentRecordSyncCursorLazyQuery>;
export type DocumentRecordSyncCursorSuspenseQueryHookResult = ReturnType<typeof useDocumentRecordSyncCursorSuspenseQuery>;
export type DocumentRecordSyncCursorQueryResult = ApolloReactCommon.QueryResult<DocumentRecordSyncCursorQuery, DocumentRecordSyncCursorQueryVariables>;
export const DocumentRecordRevisionsDocument = gql`
    query DocumentRecordRevisions($recordId: String!, $first: Int, $afterVersion: Int) {
  documentRecordRevisions(
    recordId: $recordId
    first: $first
    afterVersion: $afterVersion
  ) {
    nodes {
      id
      recordId
      version
      values
      actorUserId
      createdAt
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useDocumentRecordRevisionsQuery__
 *
 * To run a query within a React component, call `useDocumentRecordRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentRecordRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentRecordRevisionsQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *      first: // value for 'first'
 *      afterVersion: // value for 'afterVersion'
 *   },
 * });
 */
export function useDocumentRecordRevisionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentRecordRevisionsQuery, DocumentRecordRevisionsQueryVariables> & ({ variables: DocumentRecordRevisionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentRecordRevisionsQuery, DocumentRecordRevisionsQueryVariables>(DocumentRecordRevisionsDocument, options);
      }
export function useDocumentRecordRevisionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentRecordRevisionsQuery, DocumentRecordRevisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentRecordRevisionsQuery, DocumentRecordRevisionsQueryVariables>(DocumentRecordRevisionsDocument, options);
        }
// @ts-ignore
export function useDocumentRecordRevisionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordRevisionsQuery, DocumentRecordRevisionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentRecordRevisionsQuery, DocumentRecordRevisionsQueryVariables>;
export function useDocumentRecordRevisionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordRevisionsQuery, DocumentRecordRevisionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentRecordRevisionsQuery | undefined, DocumentRecordRevisionsQueryVariables>;
export function useDocumentRecordRevisionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordRevisionsQuery, DocumentRecordRevisionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentRecordRevisionsQuery, DocumentRecordRevisionsQueryVariables>(DocumentRecordRevisionsDocument, options);
        }
export type DocumentRecordRevisionsQueryHookResult = ReturnType<typeof useDocumentRecordRevisionsQuery>;
export type DocumentRecordRevisionsLazyQueryHookResult = ReturnType<typeof useDocumentRecordRevisionsLazyQuery>;
export type DocumentRecordRevisionsSuspenseQueryHookResult = ReturnType<typeof useDocumentRecordRevisionsSuspenseQuery>;
export type DocumentRecordRevisionsQueryResult = ApolloReactCommon.QueryResult<DocumentRecordRevisionsQuery, DocumentRecordRevisionsQueryVariables>;
export const DocumentRecordChangesDocument = gql`
    query DocumentRecordChanges($after: String!, $limit: Int) {
  documentRecordChanges(after: $after, limit: $limit) {
    cursor
    resetRequired
    changes {
      cursor
      recordId
      version
      type
      snapshot
    }
  }
}
    `;

/**
 * __useDocumentRecordChangesQuery__
 *
 * To run a query within a React component, call `useDocumentRecordChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentRecordChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentRecordChangesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDocumentRecordChangesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentRecordChangesQuery, DocumentRecordChangesQueryVariables> & ({ variables: DocumentRecordChangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentRecordChangesQuery, DocumentRecordChangesQueryVariables>(DocumentRecordChangesDocument, options);
      }
export function useDocumentRecordChangesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentRecordChangesQuery, DocumentRecordChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentRecordChangesQuery, DocumentRecordChangesQueryVariables>(DocumentRecordChangesDocument, options);
        }
// @ts-ignore
export function useDocumentRecordChangesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordChangesQuery, DocumentRecordChangesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentRecordChangesQuery, DocumentRecordChangesQueryVariables>;
export function useDocumentRecordChangesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordChangesQuery, DocumentRecordChangesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentRecordChangesQuery | undefined, DocumentRecordChangesQueryVariables>;
export function useDocumentRecordChangesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentRecordChangesQuery, DocumentRecordChangesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentRecordChangesQuery, DocumentRecordChangesQueryVariables>(DocumentRecordChangesDocument, options);
        }
export type DocumentRecordChangesQueryHookResult = ReturnType<typeof useDocumentRecordChangesQuery>;
export type DocumentRecordChangesLazyQueryHookResult = ReturnType<typeof useDocumentRecordChangesLazyQuery>;
export type DocumentRecordChangesSuspenseQueryHookResult = ReturnType<typeof useDocumentRecordChangesSuspenseQuery>;
export type DocumentRecordChangesQueryResult = ApolloReactCommon.QueryResult<DocumentRecordChangesQuery, DocumentRecordChangesQueryVariables>;
export const CreateDocumentRecordDocument = gql`
    mutation CreateDocumentRecord($input: CreateDocumentRecordInput!) {
  createDocumentRecord(input: $input) {
    id
    workspaceId
    documentCollectionId
    version
    values
    createdByUserId
    updatedByUserId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateDocumentRecordMutation__
 *
 * To run a mutation, you first call `useCreateDocumentRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentRecordMutation, { data, loading, error }] = useCreateDocumentRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentRecordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDocumentRecordMutation, CreateDocumentRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDocumentRecordMutation, CreateDocumentRecordMutationVariables>(CreateDocumentRecordDocument, options);
      }
export type CreateDocumentRecordMutationHookResult = ReturnType<typeof useCreateDocumentRecordMutation>;
export type CreateDocumentRecordMutationResult = ApolloReactCommon.MutationResult<CreateDocumentRecordMutation>;
export const PatchDocumentRecordDocument = gql`
    mutation PatchDocumentRecord($input: PatchDocumentRecordInput!) {
  patchDocumentRecord(input: $input) {
    id
    workspaceId
    documentCollectionId
    version
    values
    createdByUserId
    updatedByUserId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __usePatchDocumentRecordMutation__
 *
 * To run a mutation, you first call `usePatchDocumentRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchDocumentRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchDocumentRecordMutation, { data, loading, error }] = usePatchDocumentRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatchDocumentRecordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PatchDocumentRecordMutation, PatchDocumentRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PatchDocumentRecordMutation, PatchDocumentRecordMutationVariables>(PatchDocumentRecordDocument, options);
      }
export type PatchDocumentRecordMutationHookResult = ReturnType<typeof usePatchDocumentRecordMutation>;
export type PatchDocumentRecordMutationResult = ApolloReactCommon.MutationResult<PatchDocumentRecordMutation>;
export const DeleteDocumentRecordDocument = gql`
    mutation DeleteDocumentRecord($input: DeleteDocumentRecordInput!) {
  deleteDocumentRecord(input: $input)
}
    `;

/**
 * __useDeleteDocumentRecordMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentRecordMutation, { data, loading, error }] = useDeleteDocumentRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDocumentRecordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDocumentRecordMutation, DeleteDocumentRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDocumentRecordMutation, DeleteDocumentRecordMutationVariables>(DeleteDocumentRecordDocument, options);
      }
export type DeleteDocumentRecordMutationHookResult = ReturnType<typeof useDeleteDocumentRecordMutation>;
export type DeleteDocumentRecordMutationResult = ApolloReactCommon.MutationResult<DeleteDocumentRecordMutation>;
export const ImportDocumentRecordsDocument = gql`
    mutation ImportDocumentRecords($inputs: [CreateDocumentRecordInput!]!) {
  importDocumentRecords(inputs: $inputs) {
    id
    workspaceId
    documentCollectionId
    version
    values
    createdByUserId
    updatedByUserId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useImportDocumentRecordsMutation__
 *
 * To run a mutation, you first call `useImportDocumentRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportDocumentRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importDocumentRecordsMutation, { data, loading, error }] = useImportDocumentRecordsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useImportDocumentRecordsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ImportDocumentRecordsMutation, ImportDocumentRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ImportDocumentRecordsMutation, ImportDocumentRecordsMutationVariables>(ImportDocumentRecordsDocument, options);
      }
export type ImportDocumentRecordsMutationHookResult = ReturnType<typeof useImportDocumentRecordsMutation>;
export type ImportDocumentRecordsMutationResult = ApolloReactCommon.MutationResult<ImportDocumentRecordsMutation>;